import { DEAL_ADDITIONAL_NOTES_MAX_CHARS } from '@protoss/shared';
import { TextArea } from '@protoss/ui';

/**
 * Optional "Additional notes" box under a deal's document upload (new-deal panel and the existing
 * deal's "Upload documents" dialog): free text about the WHOLE deal, not about the files. It is
 * controlled by the parent, which saves it on submit and hands it to the analysis run.
 */
export function DealAdditionalNotesBox({
  value,
  onChange,
  disabled,
}: {
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
}) {
  return (
    <div className="deal-additional-notes">
      <TextArea
        label="Additional notes (optional)"
        showOptionalText={false}
        rows={3}
        value={value}
        maxLength={DEAL_ADDITIONAL_NOTES_MAX_CHARS}
        disabled={disabled}
        placeholder="Anything else coSow should know about this deal - e.g. the client wants to go live by March, they already use Shopify, keep the first phase small."
        onChange={(e) => onChange(e.target.value)}
      />
      <span className="deal-additional-notes__counter" aria-live="polite">
        {value.length.toLocaleString('en-US')} /{' '}
        {DEAL_ADDITIONAL_NOTES_MAX_CHARS.toLocaleString('en-US')}
      </span>
    </div>
  );
}
